import React from 'react'
import ClassLearner from '../../modules/ClassLearner'

const ClassLearnerPage = () => {
  return <ClassLearner />
}

export default ClassLearnerPage
